import DeliveryQuestions from '@/content/faqs/answers/signup/delivery.json';

export default class FaqDelivery {
    /**
     * Get the delivery questions.
     *
     * @return {Promise}
     */
    handle() {
        return new Promise((resolve) => resolve(DeliveryQuestions.items));
    };
}
